<template>
    <div>
        <div class="create-box">
            <div class="create-box-title">
                <h2>
                    {{appraisalInfo.name}} - {{appraisalInfo.course_name}}
                    <span style="float:right;">
                        <Button type="primary" @click="submitModal=true">提交考评</Button>
                    </span>
                </h2>
            </div>
            <Row>
                <Col span="11">
                    <Card>
                        <div slot="title">
                            <Select size="small" style="width:150px" v-model="currentSelect.classes_id" placeholder="请选择班级">
                                <Option :value="item.id" v-for="item in appraisalInfo.classes_info">{{item.name}}</Option>
                            </Select>
                            <Select size="small" style="width:150px" v-model="currentSelect.chapters_id" @on-clear="changeChapters" placeholder="请选择章" clearable @on-change="changeChapters">
                                <Option :value="item.id" v-for="item in appraisalInfo.chapters">{{item.name}}</Option>
                            </Select>
                            <Select size="small" style="width:130px" v-model="currentSelect.sub_id" placeholder="请选择节">
                                <Option :value="item.id" v-for="item in subsections">{{item.name}}</Option>
                            </Select>
                            &nbsp;
                            <Button @click="search">查询</Button>
                        </div>
                        <Table border :columns="userColumns" :data="userData"></Table>
                    </Card>
                </Col>
                <Col span="12" offset="1" v-show="currentStudentInfo.name !== '' ">
                    <Card dis-hover>
                        <p slot="title" style="color:red;height: auto;">
                            <span>
                                <Tag size="large" color="primary">学生：{{currentStudentInfo.name}}</Tag>
                            </span>
                        <span style="float:right;font-size:12px;">

                            </span>
                        <span>
                                <Button style="float:right;" size="small" @click="showModal">评价打分</Button>
                            </span>
                    </p>
                        <div style="width:100%;" v-show="videoShow">
                            <video width="100%" ref="videoPlay" controls="" autoplay="" name="media">
                                <source ref='video' id="source" src="" type="video/webm">
                            </video>
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
        <Modal
                v-model="scoreModal"
                title="评价打分"
                @on-ok="submitScore"
                :loading="loading">
            <div style="height:100px;overflow-y:auto;" v-if="currentStudentInfo.status == 3">
                <List border size="small">
                    <ListItem>
                        <ListItemMeta avatar="" :title="currentStudentInfo.score.toString()" :description="currentStudentInfo.comment" />
                        <template slot="extra">
                            {{currentStudentInfo.submit_time}}
                        </template>
                    </ListItem>
                </List>
            </div>
            <Form ref="submitScoreForm" :model="submitScoreForm" :rules="submitScoreValidate">
                <FormItem label="评价:" prop="comment">
                    <Input type="textarea" v-model="submitScoreForm.comment" :autosize="{minRows: 2,maxRows: 5}" style="width:90%;" placeholder="请输入评价"></Input>
                </FormItem>
                <FormItem label="打分" prop="score">
                    <InputNumber v-model="submitScoreForm.score" :max="100" :min="1" :step="1"></InputNumber>
                </FormItem>
            </Form>
        </Modal>

        <!-- 提交考评-->
        <Modal
                v-model="submitModal"
                title="提交考评"
                @on-ok="submitAppraisalInfo"
        >
            <p style="color:red;">确认提交考评吗，提交之后不可修改编辑。</p>
        </Modal>

    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    export default {
        name:'correct',
        data(){
            return {
                submitModal:false,
                videoShow:false,
                currentStudentInfo:{
                    name:'',
                },
                currentSelect:{
                    classes_id:0,
                    sub_id:0,
                    chapters_id:0,
                },
                submitScoreForm:{
                    score:0,
                    comment:'',
                },
                loading:true,
                submitScoreValidate:{
                    comment:[
                        {
                            required:true,message:"评价必填",trigger: 'blur',type:'string'
                        }
                    ],
                    score:[
                        {
                            required:true,message:"分数必填",trigger: 'blur',type:'number'
                        }
                    ]
                },
                subsections:[],
                appraisalInfo:{},
                scoreModal:false,
                userColumns:[
                    {
                        title:'姓名',
                        key:'name',
                        render:(h,params)=>{
                            return h('div',[
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.getDetailVideo(params.row);
                                        }
                                    }
                                }, params.row.name),
                            ])
                        }
                    },
                    {
                        title:'状态',
                        key:'status_name'
                    }
                ],
                userData:[],
            }
        },
        methods:{
            ...mapActions({
                getAppraisalInfo:'appraisal/getAppraisalInfo',
                getSubClassStudents:'appraisal/getSubClassStudents',
                setStudentScore:'appraisal/setStudentScore',
                submitAppraisal:'appraisal/submitAppraisal',
            }),
            showModal(){
                this.scoreModal = !this.scoreModal;
            },
            // 获取学生提交信息
            getDetailVideo(param){
                this.videoShow = true;
                this.$refs.video.src = param.address;
                this.$nextTick(() => {
                    this.$refs.videoPlay.load();
                });

                this.currentStudentInfo = param;
            },
            // 提交竞赛
            submitAppraisalInfo(){
                let _this = this;
                this.submitAppraisal({
                    data:{
                        examine_id:_this.id,
                    },
                    callback:res=>{
                        _this.$router.push({
                            name:'appraisalList'
                        })
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            },

            // 选择章节后
            changeChapters(value){
                this.subsections = [];
                this.appraisalInfo.chapters.forEach(item=>{
                    if(item.id == value){
                        if(item.hasOwnProperty('subsections')){
                            this.subsections = item.subsections;
                        }
                    }
                })
            },
            // 查询
            search(){
                let _this = this;
                if(_this.currentSelect.sub_id > 0 && _this.currentSelect.classes_id > 0 ){
                    this.getSubClassStudents({
                        data:{
                            examine_id:_this.id,
                            sub_id:_this.currentSelect.sub_id,
                            class_id:_this.currentSelect.classes_id,
                        },
                        callback:res=>{
                            _this.userData = res;
                        }
                    })
                }else{
                    this.$Message.error("选项不能为空");
                }
            },
            changeLoading() {
                this.loading = false;
                this.$nextTick(() => {
                    this.loading = true;
                });
            },
            // 打分评价
            submitScore(){
                let _this = this;
                this.$refs['submitScoreForm'].validate((valid) => {
                    if(valid){
                        _this.setStudentScore({
                            data:{
                                examine_id:_this.id,
                                sub_id:_this.currentSelect.sub_id,
                                uid:_this.currentStudentInfo.id,
                                body:_this.submitScoreForm
                            },
                            callback:res=>{
                                _this.search();
                                _this.$Message.success("打分完成");
                                _this.scoreModal = false;

                                // 静态设置modal弹窗中的信息
                                _this.currentStudentInfo.score = _this.submitScoreForm.score;
                                _this.currentStudentInfo.comment = _this.submitScoreForm.comment;

                                _this.submitScoreForm.score = 0;
                                _this.submitScoreForm.comment = '';
                                // 调用查询
                                _this.search();
                            },
                            error:msg=>{
                                this.$Message.error(msg);
                            }

                        });
                    }else{
                        return this.changeLoading();
                    }
                })
            }
        },
        mounted() {
            let _this = this;
            _this.id = this.$route.query.id;
            if(_this.id > 0 ){
                // 获取编辑信息
                this.getAppraisalInfo({
                    id:_this.id,
                    callback:res=>{
                        _this.appraisalInfo = res;
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            }
        }
    }
</script>
<style scoped lang="less">
    .create-box{
        min-height: 765px;
    }
    .left{
        float:left;
        width:30%;
        background-color:red;
    }
    .right{
        float:left;
        width:70%;
        background-color:blue;
    }
    @import "../../style/index";
    @import "../../../../assets/style/exercises";
</style>
